import { render, staticRenderFns } from "./StitchingDetailRow.vue?vue&type=template&id=6172721d&scoped=true"
import script from "./StitchingDetailRow.vue?vue&type=script&lang=js"
export * from "./StitchingDetailRow.vue?vue&type=script&lang=js"
import style0 from "./StitchingDetailRow.vue?vue&type=style&index=0&id=6172721d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172721d",
  null
  
)

export default component.exports